<ng-container>
  <div class="{{ viewMode }} user-management-page">
    @if (loading) {
    <mic-spinner ariaLabel="In Progress" color="accent" [strokeWidth]="5"></mic-spinner>
    } @if (!loading) {
    <form [formGroup]="userFormGroup" (ngSubmit)="validateUserDetailsAndSaveChanges()">
      <div class="w-full items-center justify-between" formGroupName="userInfo">
        <div class="px-5 mb-4">
          <div class="flex flex-row mt-6 mb-3 place-items-center justify-between align-items-center">
            <div class="flex flex-start place-items-center align-items-center">
              <h2 id="customer-heading" class="page-title">{{ translationService.translate('userInformationText') }}</h2>
            </div>
            <div class="flex flex-end place-items-center align-items-center mr-4">
              @if (editMode) {
              <button
                id="save-button"
                type="submit"
                mat-flat-button
                color="primary"
                class="mic-btn-icon-left btn-primary"
                [loading]="isSaving"
              >
                <mat-icon>save</mat-icon>
                <span>{{ translationService.translate('saveLinkText') }}</span>
              </button>
              }
            </div>
          </div>
        </div>
        <div class="px-5 flex flex-row flex-nowrap">
          <div class="flex flex-auto">
            <mat-form-field class="mr-4 mb-4 editable-field" subscriptSizing="dynamic" id="last-name-field">
              <mat-label>{{ translationService.translate('lastNameText') }}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                [formControlName]="'lastName'"
                (input)="onInputChange('userInfo', 'lastName', $event.target)"
                required
              />
              @if (userInfoFormGroup.get('lastName').hasError('required')) {
              <mat-error id="last-name-error">{{ translationService.translate('mandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="mr-4 mb-4 editable-field" subscriptSizing="dynamic" id="first-name-field">
              <mat-label>{{ translationService.translate('firstNameText') }}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                [formControlName]="'firstName'"
                (input)="onInputChange('userInfo', 'firstName', $event.target)"
                required
              />
              @if (userInfoFormGroup.get('firstName').hasError('required')) {
              <mat-error id="first-name-error">{{ translationService.translate('mandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="mr-4 mb-4 editable-field" subscriptSizing="dynamic" id="login-name-field">
              <mat-label>{{ translationService.translate('loginNameText') }}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                [formControlName]="'username'"
                (input)="onInputChange('userInfo', 'username', $event.target)"
                required
              />
              @if (userInfoFormGroup.get('username').hasError('required')) {
              <mat-error id="login-name-error">{{ translationService.translate('mandatoryFieldText') }}</mat-error>
              } @if (userInfoFormGroup.get('username').hasError('whitespaceOrSpecialCharacters')) {
              <mat-error id="space-special-character-error">
                {{ translationService.translate('spaceAndSpecialCharactersAreNotAllowedText') }}
              </mat-error>
              } @if (userInfoFormGroup.get('username').hasError('usernameExists')) {
              <mat-error id="login-name-already-exists-error">
                {{ translationService.translate('loginNameAlreadyExistsText') }}
              </mat-error>
              }
            </mat-form-field>
            <div class="mr-5">
              <app-dropdown-multiple-search
                id="user-group-field"
                [editMode]="editMode"
                [id]="'user-group-field'"
                [options]="groupNames"
                [formGroup]="userInfoFormGroup"
                [multipleOption]="false"
                [controlName]="'selectedUserGroup'"
                [label]="translationService.translate('userGroupText')"
                (onDropdownOpenedChange)="onSelectionChange('selectedUserGroup', 'userGroup', $event)"
              />
            </div>

            <span class="flex mr-8 mb-4 items-center" style="align-items: center">
              <span class="mr-1" id="active-label">{{ translationService.translate('activeText') }}</span>
              <mat-slide-toggle id="active-switch" (change)="onSlideToggleButtonChange($event)" formControlName="active_Flg">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </span>
            <span class="flex mr-8 mb-4 items-center" style="align-items: center">
              <span class="mr-1" id="sales-id-label">{{ translationService.translate('salesIdText') }}</span>
              <mat-slide-toggle id="sales-id-switch" (change)="onSalesmanToggleButtonChange($event)" formControlName="salesman">
                {{
                  userInfoFormGroup.get('salesman')?.value
                    ? translationService.translate('yesText')
                    : translationService.translate('noText')
                }}
              </mat-slide-toggle>
            </span>
          </div>
        </div>

        <div class="px-5 flex flex-row flex-nowrap">
          <div class="flex flex-auto">
            <div class="mr-4">
              <app-dropdown-multiple-search
                id="location-type-field"
                [editMode]="editMode"
                [id]="'location-type-field'"
                [options]="locationTypes"
                [formGroup]="userInfoFormGroup"
                [multipleOption]="false"
                [controlName]="'selectedLocationType'"
                [label]="translationService.translate('locationTypeText')"
              />
            </div>
            <div class="mr-4">
              <app-dropdown-multiple-search
                id="location-field"
                [editMode]="editMode"
                [id]="'location-field'"
                [options]="locations"
                [formGroup]="userInfoFormGroup"
                [multipleOption]="false"
                [controlName]="'selectedLocation'"
                [label]="translationService.translate('locationText')"
              />
            </div>
            <div class="mr-4">
              <app-dropdown-multiple-search
                id="language-field"
                [editMode]="editMode"
                [id]="'user-prefence-language'"
                [options]="languages"
                [formGroup]="userInfoFormGroup"
                [multipleOption]="false"
                [controlName]="'selectedLanguage'"
                [label]="translationService.translate('languageDropdownLabelText')"
                (onDropdownOpenedChange)="onSelectionChange('selectedLanguage', 'language', $event)"
              />
            </div>
            <mat-form-field
              class="mr-4 mb-4 editable-field"
              [class.readonly-field]="username && username.trim() !== ''"
              subscriptSizing="dynamic"
              id="btm-id-field"
            >
              <mat-label>{{ translationService.translate('btmUserIdText') }}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                [formControlName]="'btmId'"
                (input)="onInputChange('userInfo', 'btmId', $event.target)"
                [readonly]="username && username.trim() !== ''"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="px-5 mr-4 mt-4 flex flex-row">
          <!-- Password Fields Container -->
          <div class="flex flex-col">
            <!-- Password Field -->
            @if (isAddMode) {
            <mat-form-field class="mr-4 mb-4 flex-grow editable-field" subscriptSizing="dynamic" id="password-field">
              <mat-label>{{ translationService.translate('passwordLabelText') }}</mat-label>
              <input
                matInput
                #newPasswordInput
                [type]="hideNew ? 'password' : 'text'"
                placeholder=""
                [formControlName]="'password'"
                (input)="onInputChange('userInfo', 'password', $event.target)"
                required
              />
              <a
                mat-icon-button
                matSuffix
                id="hideNew"
                (click)="hideNew = !hideNew"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideNew"
              >
                <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
              </a>
              @if (userInfoFormGroup.get('password').hasError('required')) {
              <mat-error id="password-error">{{ translationService.translate('mandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>
            }

            <!-- Confirm Password Field -->
            @if (isAddMode) {
            <mat-form-field class="mr-4 flex-grow editable-field" subscriptSizing="dynamic" id="confirm-password-field">
              <mat-label>{{ translationService.translate('confirmPasswordText') }}</mat-label>
              <input
                matInput
                #confirmPasswordInput
                [type]="hideConfirm ? 'password' : 'text'"
                placeholder=""
                [formControlName]="'confirmPassword'"
                (input)="onInputChange('userInfo', 'confirmPassword', $event.target)"
                required
              />
              <a
                mat-icon-button
                matSuffix
                id="hideConfirm"
                (click)="hideConfirm = !hideConfirm"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirm"
              >
                <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
              </a>
              @if (userInfoFormGroup.get('confirmPassword').hasError('required')) {
              <mat-error id="confirm-password-error">{{ translationService.translate('mandatoryFieldText') }}</mat-error>
              } @if (userInfoFormGroup.get('confirmPassword').hasError('matching')) {
              <mat-error id="do-not-match-error">{{ translationService.translate('passwordDoNotMatchText') }}</mat-error>
              }
            </mat-form-field>
            }
          </div>

          <!-- Password Requirements (Placed to the right) -->
          @if (isAddMode) {
          <div class="password-requirements ml-4">
            <div class="highlight-label" style="font-weight: 400; color: rgba(0, 0, 0, 0.89)">
              {{ translationService.translate('passwordContainText') }}
            </div>
            <ul style="margin-left: 10px">
              <li id="atleast-ten-char" [ngStyle]="{ color: checkMinLength(currentFocusInput) }" class="highlight-label">
                {{ translationService.translate('atLeastTenCharText') }}
              </li>
              <li class="highlight-label">{{ translationService.translate('atLeastThreeReqText') }}</li>
              <ul style="margin-top: 5px">
                <li [ngStyle]="{ color: checkPasswordCriteriaUpper(currentFocusInput) }" class="highlight-label">
                  {{ translationService.translate('oneCapitalText') }}
                </li>
                <li [ngStyle]="{ color: checkPasswordCriteriaLower(currentFocusInput) }" class="highlight-label">
                  {{ translationService.translate('oneSmallText') }}
                </li>
                <li [ngStyle]="{ color: checkPasswordCriteriaNumber(currentFocusInput) }" class="highlight-label">
                  {{ translationService.translate('oneNumberText') }}
                </li>
                <li [ngStyle]="{ color: checkPasswordCriteriaSpecial(currentFocusInput) }" class="highlight-label">
                  {{ translationService.translate('specialCharText') }}
                </li>
              </ul>
            </ul>
          </div>
          }
        </div>

        <div class="px-5 my-8">
          <div class="flex flex-row items-center">
            <mat-icon style="color: #27509b">info</mat-icon>
            <p id="customer-access-message" class="flex-1">
              {{ translationService.translate('restrictCustomerAccessMessageText') }}
            </p>
          </div>
          <div class="items-center">
            <span class="mr-4" id="restrict-customer-access-label">{{ translationService.translate('restrictCustomerAccessText') }}</span>
            <ng-container style="padding: 5%">
              <mat-slide-toggle
                [disabled]="!userInfoFormGroup.valid"
                [matTooltipDisabled]="isAddMode"
                id="restrict-customer-access-switch"
                formControlName="restrictCustomerAccess"
                (change)="onRestrictCustomerAccessToggle($event)"
                matTooltip="{{ translationService.translate('enableYesToRestrictUserAccessText') }}"
                matTooltipPosition="right"
              >
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
              @if (showRestrictCustomerAccessButton) {
              <button
                [disabled]="!hasRolePermission(ROLES.edit_user)"
                class="ml-4 btn-primary"
                color="primary"
                id="restrict-customer-access-button"
                mat-flat-button
                type="button"
                (click)="openSelectCustomerScreen()"
              >
                <mat-icon fontSet="outlined">edit</mat-icon>
                {{ translationService.translate('selectCustomerText') }}
              </button>
              }
            </ng-container>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="px-5 my-8">
        <div formGroupName="userPermissionInfo">
          <h3 class="px-5 mb-4" id="user-group-permission-heading">{{ translationService.translate('userGroupPermissionText') }}</h3>
          <div class="px-5 mb-4 flex flex-row" formGroupName="shopfloorPostsPermissions">
            <div class="flex-auto">
              <mat-accordion hideToggle style="margin-bottom: 20px">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header class="section-header-style">
                    <mat-panel-title>
                      {{ translationService.translate('shopfloorPostsPermissionsText') }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-divider></mat-divider>
                  @for (item of shopFloorPermissions; track item.id; let i = $index) {
                  <div class="row" style="margin-top: 10px">
                    <div class="column section-border">
                      <div class="row">
                        <div class="column">
                          @if (item.id !== 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start" style="margin-left: 10px"
                            >{{ this.translationService.translate(item.leftSideLabel) }}
                          </mat-label>
                          }
                        </div>
                        <div class="column">
                          @if (item.id === 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                            >{{ this.translationService.translate(item.leftSideLabel) }}
                          </mat-label>
                          } @if (item.id !== 0) {
                          <mat-checkbox
                            class="flex flex-row flex-1 gap-4 justify-end"
                            [checked]="item.isCheckedLeftBox"
                            disabled
                          ></mat-checkbox>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <div class="row">
                        <div class="column">
                          @if (item.id !== 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start" style="margin-left: 10px"
                            >{{ this.translationService.translate(item.rightSideLabel) }}
                          </mat-label>
                          }
                        </div>
                        <div class="column">
                          @if (item.id === 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                            >{{ this.translationService.translate(item.rightSideLabel) }}
                          </mat-label>
                          } @if (item.id !== 0 && item.rightSideLabel !== '') {
                          <mat-checkbox
                            class="flex flex-row flex-1 gap-4 justify-end"
                            [checked]="item.isCheckedRightBox"
                            disabled
                          ></mat-checkbox>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>

          <div class="px-5 mb-4 flex flex-row" formGroupName="generalPermissions">
            <div class="flex-auto">
              <mat-accordion hideToggle style="margin-bottom: 20px">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header class="section-header-style">
                    <mat-panel-title>
                      {{ translationService.translate('generalPermissionsText') }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-divider></mat-divider>
                  @for (item of generalPermissions; track item.id; let i = $index) {
                  <div class="row" style="margin-top: 10px">
                    <div class="column section-border">
                      <div class="row">
                        <div class="column">
                          @if (item.id !== 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start" style="margin-left: 10px"
                            >{{ this.translationService.translate(item.leftSideLabel) }}
                          </mat-label>
                          }
                        </div>
                        <div class="column">
                          @if (item.id === 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                            >{{ this.translationService.translate(item.leftSideLabel) }}
                          </mat-label>
                          } @if (item.id !== 0) {
                          <mat-checkbox
                            class="flex flex-row flex-1 gap-4 justify-end"
                            [checked]="item.isCheckedLeftBox"
                            disabled
                          ></mat-checkbox>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <div class="row">
                        <div class="column">
                          @if (item.id !== 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start" style="margin-left: 10px"
                            >{{ this.translationService.translate(item.rightSideLabel) }}
                          </mat-label>
                          }
                        </div>
                        <div class="column">
                          @if (item.id === 0) {
                          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                            >{{ this.translationService.translate(item.rightSideLabel) }}
                          </mat-label>
                          } @if (item.id !== 0 && item.rightSideLabel !== '') {
                          <mat-checkbox
                            class="flex flex-row flex-1 gap-4 justify-end"
                            [checked]="item.isCheckedRightBox"
                            disabled
                          ></mat-checkbox>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
          <div class="px-5 mb-4 flex flex-row" formGroupName="backofficePermissions">
            <div class="flex-auto">
              <mat-accordion hideToggle>
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header class="section-header-style">
                    <mat-panel-title>
                      {{ translationService.translate('backofficePermissionsText') }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-divider></mat-divider>
                  @for (item of backOfficePermissions; track item.id; let i = $index) {
                  <div class="row" style="margin-top: 10px">
                    <div class="column">
                      @if (item.id !== 0) {
                      <mat-label class="flex flex-row flex-1 gap-4 justify-start" style="margin-left: 10px"
                        >{{ this.translationService.translate(item.leftSideLabel) }}
                      </mat-label>
                      }
                    </div>
                    <div class="column flex flex-row flex-1 gap-4 justify-start"></div>
                    <div class="column">
                      @if (item.id === 0) {
                      <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title" style="margin-left: 10px"
                        >{{ this.translationService.translate('allText') }}
                      </mat-label>
                      } @if (item.id !== 0) {
                      <mat-checkbox class="flex flex-row flex-1 gap-4 justify-end" [checked]="item.isAllChecked" disabled></mat-checkbox>
                      }
                    </div>
                    <div class="column">
                      @if (item.id === 0) {
                      <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                        >{{ this.translationService.translate('viewText') }}
                      </mat-label>
                      } @if (item.id !== 0) {
                      <mat-checkbox class="flex flex-row flex-1 gap-4 justify-end" [checked]="item.isViewChecked" disabled> </mat-checkbox>
                      }
                    </div>
                    <div class="column">
                      @if (item.id === 0) {
                      <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                        >{{ this.translationService.translate('editLinkText') }}
                      </mat-label>
                      } @if (item.id !== 0) {
                      <mat-checkbox class="flex flex-row flex-1 gap-4 justify-end" [checked]="item.isEditChecked" disabled> </mat-checkbox>
                      }
                    </div>
                    <div class="column">
                      @if (item.id === 0) {
                      <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                        >{{ this.translationService.translate('createButtonText') }}
                      </mat-label>
                      } @if (item.id === 1) {
                      <mat-checkbox class="flex flex-row flex-1 gap-4 justify-end" [checked]="item.isCreateChecked" disabled></mat-checkbox>
                      }
                    </div>
                  </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </div>
    </form>
    }
  </div>
</ng-container>

<ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
<mic-modal class="modalC" #unsavedChangesModal></mic-modal>

<ng-template #noCustomerAssignedWarning>{{ this.translationService.translate('noCustomersAssignedText') }}</ng-template>
<mic-modal class="modalC" #noCustomerAssignedModal (result)="onNoCustomerAssignedModalClosed($event)"></mic-modal>

<ng-template #removeAssignedCustomersModalWarning>{{ this.translationService.translate('userHasLimitedCustomerAccessText') }} </ng-template>
<mic-modal class="modalC" #removeAssignedCustomersModal (result)="onRemoveAssignedCustomersModalClosed($event)"></mic-modal>

<div class="audit-container">
  @if (!isAddMode) {
  <p id="audit-modified">
    {{ this.translationService.translate('lastUpdatedText') }} : {{ lastUpdateTime }} {{ this.translationService.translate('byText') }}
    {{ lastUpdatedBy }}
  </p>
  } @if (!isAddMode) {
  <p id="audit-created">
    {{ this.translationService.translate('camCreateSuccessTitleText') }} : {{ createdTime }}
    {{ this.translationService.translate('byText') }} {{ createdBy }}
  </p>
  }
</div>
